<script lang="ts" setup>
import { ref, onMounted } from 'vue'
import { DTextField, DIcon, CheckIcon } from 'front-library'
import { Payroll } from '@/app/core/services/payrolls'
import { useI18n } from 'vue-i18n'

const props = defineProps<{
  payrolls: Payroll[]
  payroll: Payroll
}>()

const emit = defineEmits(['change:payroll'])

const searchPayroll = ref('')
const listPayrolls = ref()
const { t } = useI18n()

/* Método para filtrar las nominas */
const filterPayrolls = () => {
  listPayrolls.value = props.payrolls.filter(
    (item: any) =>
      item.code
        .concat(' ', item.name)
        .toLowerCase()
        .indexOf(searchPayroll.value.toString().toLowerCase()) > -1
  )
  const Payrolls = document.getElementById('optionsPayroll')
  switch (listPayrolls.value.length) {
    case 0:
    case 1:
      Payrolls?.classList.add('one')
      Payrolls?.classList.remove('two')
      break
    case 2:
      Payrolls?.classList.add('two')
      Payrolls?.classList.remove('one')
      break
    default:
      Payrolls?.classList.remove('one')
      Payrolls?.classList.remove('two')
      break
  }
}

const emitPayroll = (payroll: any) => {
  emit('change:payroll', payroll)
}

const orderCode = (a: any, b: any) => {
  if (!isNaN(a.code) && !isNaN(b.code)) {
    return parseInt(a.code) - parseInt(b.code)
  }
  if (!isNaN(a.code)) {
    return -1
  }
  if (!isNaN(b.code)) {
    return 1
  }
  return a.code.localeCompare(b.code)
}

onMounted(() => {
  // Guardar la lista de nominas en una variable del componente
  listPayrolls.value = props.payrolls
  listPayrolls.value.sort(orderCode)
})
</script>
<template>
  <div
    class="sm:pl-5 lg:pl-0 lg:pr-28 justify-end flex right-0 lg:fixed"
    style="z-index: 32">
    <div class="w-100">
      <div class="pt-4 optionPayroll w-56 sm:w-96">
        <div
          class="px-6 py-3 shadow-md rounded-xl flex items-center cursor-pointer bg-white">
          <div class="px-1">
            <DIcon
              :name="payroll?.country.iso_code.toUpperCase() + 'Icon'"
              class="h-8 w-8" />
          </div>
          <div class="px-2 leading-5">
            <p
              class="font-bold text-blue-900 text-ellipsis w-32 sm:w-72 overflow-hidden whitespace-nowrap">
              {{ payroll?.code + '-' + payroll?.name }}
            </p>
            <small
              class="text-gray-500 text-ellipsis block w-32 sm:w-72 overflow-hidden whitespace-nowrap">
              {{ payroll?.company.code + '-' + payroll?.company.name }}
            </small>
          </div>
        </div>
        <div class="pt-3">
          <div
            class="fixed shadow-md rounded-xl w-56 sm:w-96"
            id="optionsPayroll">
            <div class="p-3 cursor-auto bg-white">
              <div>
                <DTextField
                  :icon="'SearchLgIcon'"
                  :placeholder="t('components.header.search')"
                  v-model="searchPayroll"
                  @keyup="filterPayrolls()" />
              </div>
              <ul class="mt-2.5 overflow-y-auto list-payrolls scroll">
                <li
                  v-for="(payrollList, i) of listPayrolls"
                  :key="i"
                  @click="emitPayroll(payrollList)"
                  class="flex items-center justify-between cursor-pointer p-1 mr-1 text-sm rounded-md border border-transparent hover:border-blue-700">
                  <div class="px-1 w-7 h-7">
                    <DIcon
                      :name="
                        (payrollList as any).country.iso_code.toUpperCase() + 'Icon'
                      " />
                  </div>
                  <div class="pr-2 pl-3 leading-4 w-full">
                    <p>
                      {{
                        (payrollList as any).code +
                        '-' +
                        (payrollList as any).name
                      }}
                    </p>
                  </div>
                  <div v-if="(payrollList as any).code == payroll.code">
                    <CheckIcon class="h-4 text-blue-500" />
                  </div>
                </li>
                <p class="p-1" v-if="listPayrolls?.length == 0">
                  {{ t('components.header.noPayrolls') }}
                </p>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.showOptions {
  overflow: hidden;
  cursor: pointer;
  transition: height 0.3s linear 0s;
}
#optionsPayroll {
  overflow: hidden;
  cursor: pointer;
  transition: height 0.3s linear 0s;
  height: 0;
}
.optionPayroll:hover #optionsPayroll {
  height: 196px;
}
.optionPayroll:hover #optionsPayroll.two {
  height: 153px;
}
.optionPayroll:hover #optionsPayroll.one {
  height: 113px;
}
.list-payrolls {
  height: 120px;
}
</style>
